export default __webpack_public_path__ + "static/media/index_fund.70d13f05.svg";